// extracted by mini-css-extract-plugin
export var statItem = "_l9-1";
export var statsRow = "_l9-0";